// src/components/store/sections/blog-posts/BlogV22TicketpressCoralFlame.tsx
"use client";

import React from "react";
import DynamicBlogVariant from "./DynamicBlogVariant";

export default function BlogV22TicketpressCoralFlame(props: any) {
  return (
    <DynamicBlogVariant
      variantNumber={22}
      archKey="ticket_press"
      archLabel="Press Pass Stub Cards"
      palName="CoralFlame"
      grad="from-orange-500 via-rose-500 to-pink-700"
      lightBg="bg-orange-50"
      textCol="text-orange-700"
      borderCol="border-orange-200"
      btnCls="bg-rose-600 hover:bg-rose-700"
      hexCol="#f97316"
      {...props}
    />
  );
}
